import React, { useRef, useContext, forwardRef, useEffect } from "react"
import { Container, Sprite, AnimatedSprite, useTick } from "@inlet/react-pixi"
import Emitter from "components/emitter"
import { TextureContext } from "utils/texture-context"
import { lerp, clamp, easeInOut } from "utils/math"
import { icons } from "global.js"

const ActiveHighlighter = ({ item, counter, x, y, ...props }) => {
  const time = useRef(0)
  const ref = useRef()

  const context = useContext(TextureContext)
  const textures = context[`${item}-spritesheet.json`]

  useTick((delta, x) => {
    time.current += x.elapsedMS
    if (ref.current) {
      const { abs } = Math
      ref.current.scale.x = lerp(
        1,
        1.25,
        1 - 2 * abs(easeInOut(clamp(time.current / 500)) - 0.5)
      )
      ref.current.scale.y = lerp(
        1,
        1.35,
        1 - 2 * abs(easeInOut(clamp(time.current / 500)) - 0.5)
      )
    }
  })
  return (
    <Container x={x} y={y}>
      <Container ref={ref} width={60} height={60} x={30} y={45}>
        <Container x={-30} y={-45}>
          {textures ? (
            <AnimatedSprite
              textures={textures}
              width={60}
              height={60}
              isPlaying={true}
              animationSpeed={textures.length / 62}
            />
          ) : (
            <Sprite width={60} height={60} image={icons[item]} />
          )}
        </Container>
      </Container>
    </Container>
  )
}

export default ActiveHighlighter
